import { Trans } from 'react-i18next';

import { usePricingQuery } from '@xver/hooks/usePricingQuery';

interface Notice {
    color: string;
    i18nKey: string;
}

const NOTICES: Notice[] = [
    {
        color: '#f59e0b',
        i18nKey: 'backup.pricing.rate',
    },
    {
        color: '#9ca3af',
        i18nKey: 'backup.pricing.actual',
    },
    {
        color: '#ef4444',
        i18nKey: 'backup.pricing.retention',
    },
];

export default function BackupPricingNotice() {
    const { data: pricingResp } = usePricingQuery();
    const rate = pricingResp?.products.backup.gb_hourly_rate ?? 0.0025;
    const monthly = Number((rate * 24 * 30).toFixed(2));

    return (
        <div className="w-full rounded-md bg-surface-1 border-[0.5px] border-line p-5 flex flex-col gap-3">
            {NOTICES.map((n, i) => (
                <div key={i} className="flex flex-row items-start gap-3 text-sm text-fg/80">
                    <span
                        className="mt-1.5 inline-block w-2 h-2 rounded-full shrink-0"
                        style={{ backgroundColor: n.color }}
                    />
                    <span>
                        <Trans
                            i18nKey={n.i18nKey}
                            ns="cloudComputeInstance"
                            components={{ 1: <b />, 3: <b /> }}
                            values={{ rate, monthly }}
                        />
                    </span>
                </div>
            ))}
        </div>
    );
}
